import React from 'react';

import { CardViewProps } from './components/card-view/card-view.types';
import { ViewKeyProps } from './components/view-key/view-key.types';

export type SwitchLabelDefaultProps = {
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void
    isChecked: boolean
};

export enum DynamicGridFiltersConstants {
    name = 'dynamicGridFilters'
}

export type DynamicGridFilterProps = {
    startDueDates: SwitchLabelDefaultProps
    voluntaryAttempts: SwitchLabelDefaultProps
    // Left out when the grid has no IH work, as the View Key leaves out its IH item.
    instructionHubTreatment?: SwitchLabelDefaultProps
    viewKey?: ViewKeyProps
    courseFilters?: React.ReactElement
    cardView?: CardViewProps
};

export type DynamicGridFiltersState = {
    showDueDates: boolean
    voluntaryAttempts: boolean
    showInstructionHubCorner: boolean
    isOpen: boolean
    isCardViewOpen: boolean
};
